import type { BasketContent, User } from '@front/common/src/types/commons';
import { hasPrestations } from '@front/common/src/utils/basket';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';
import { hasMembership } from '@front/customer/src/utils/membership';

import HasMembership from './has-membership';
import NoMembershipYet from './no-membership-yet';

type MembershipCardContentProps = {
  basketContent: BasketContent;
  user?: User;
  getMoreInfoPress: () => void;
  reduction: number;
};

const MembershipCardContent = ({ basketContent, user, getMoreInfoPress, reduction }: MembershipCardContentProps) => {
  const hasPrestationsSelected = hasPrestations(basketContent);
  const hasAlreadyMembership = hasMembership(user);
  const membershipConfig = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()];
  const membershipPrice = membershipConfig.monthlyPrice;
  const membershipReductionsPercentage = membershipConfig.wellnessReductionsPercentage;

  if (hasAlreadyMembership) {
    return (
      <HasMembership
        hasPrestationsSelected={hasPrestationsSelected}
        membershipReductionsPercentage={membershipReductionsPercentage}
        reduction={reduction}
      />
    );
  }

  return (
    <NoMembershipYet
      hasPrestationsSelected={hasPrestationsSelected}
      membershipReductionsPercentage={membershipReductionsPercentage}
      reduction={reduction}
      membershipPrice={membershipPrice}
      getMoreInfoPress={getMoreInfoPress}
    />
  );
};

export default MembershipCardContent;
